import { styles, theme } from './bulk.styles';
import { Column, Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';

type BulkStage = 'select' | 'camera' | 'generating' | 'review' | 'complete';

export function BulkStepHeader({ stage }: { stage: BulkStage }) {
  const { t } = useTranslation('new');
  const steps: BulkStage[] = ['select', 'generating', 'review', 'complete'];
  const activeIndex = Math.max(0, steps.indexOf(stage));

  return (
    <Column gap="spacing.general.x3">
      <Row
        gap="spacing.general.x1"
        accessibilityLabel={t('bulk.progress.accessibility', { current: activeIndex + 1, total: steps.length })}
      >
        {steps.map((step, index) => (
          <View
            key={step}
            style={[
              styles.stepDot,
              {
                backgroundColor:
                  index <= activeIndex
                    ? theme.colors['surface.brand.default']
                    : theme.colors['surface.tertiary-neutral'],
              },
            ]}
          />
        ))}
      </Row>
      <Column gap="spacing.general.x1">
        <Text color="text.placeholder" fontWeight="700" textTransform="uppercase" variant="bodyBase">
          {t(`bulk.steps.${stage}.eyebrow`)}
        </Text>
        <Text color="text.primary" fontWeight="700" variant="headerXSmall">
          {t(`bulk.steps.${stage}.title`)}
        </Text>
        <Text color="text.placeholder" variant="bodyBase">
          {t(`bulk.steps.${stage}.subtitle`)}
        </Text>
      </Column>
    </Column>
  );
}
